import Tracker from './components/Tracker';
import trackingListeners from './listeners';

const configureStore = () => new Tracker(trackingListeners);

export default configureStore();
